module.exports = __webpack_public_path__ + "d7bd06971daabaad99cc3c4ecd8f2fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_bg3.png
// module id = 206
// module chunks = 1